import { useDataTableUsingState, } from '@juvare/common-data-table-ui/DataTable';
import { FiltersBar } from '@juvare/common-data-table-ui/FiltersBar';
import { maxUrlSearchLength } from '@juvare/contact-management/utils/constants';
import React from 'react';
import { useFileColumns } from './useFileColumns';
import { mapFileFilter, useFileList } from './useFileList';
import { useFilesFilterConfig } from './useFilesFilterConfig';
export function useFileTable({ useDataTableFunction = useDataTableUsingState, defaultPermissions, currentDirectoryId, navigate, onManagePermissions, staticFilterData, customRowMenuItems, }) {
    const params = {
        useDataProvider: (request) => useFileList(request, mapFileFilter, staticFilterData, currentDirectoryId),
        defaultRowsPerPage: 100,
        defaultSortColumnKey: 'name',
        maxUrlSearchLength,
        onRowClick: () => undefined,
    };
    const { dataTableProps, filtersBarProps, appliedFilterData, clearActiveRow, reload, setSelectedRowIds, setActiveRowId } = useDataTableFunction(params);
    const filterConfig = useFilesFilterConfig();
    return {
        dataTableProps: Object.assign(Object.assign({}, dataTableProps), { columns: useFileColumns({
                defaultPermissions,
                clearActiveRow,
                navigate,
                reload,
                onManagePermissions,
                isSearching: !!appliedFilterData.search,
                customRowMenuItems,
            }), filtersBar: React.createElement(FiltersBar, Object.assign({}, filtersBarProps, { config: filterConfig })), tableSx: { tableLayout: 'fixed' } }),
        filtersBarProps: filtersBarProps,
        appliedFilterData: appliedFilterData,
        clearActiveRow: clearActiveRow,
        setActiveRowId: setActiveRowId,
        setSelectedRowIds: setSelectedRowIds,
        reload: reload,
    };
}
